import React, {Component} from 'react';
import _ from 'underscore'
import {dataAutomationAttr, isMobile} from 'helpers/ApplicationHelper';

class MultipleButtons extends Component {
    constructor(props) {
        super(props);

        this.state = {
            buttons: _.map(this.props.message.buttons, (button)=>{return button;}),
            stickyButtons: _.map(this.props.message.stickyButtons, (button)=>{return button;}),
            selectedButton: "0"
        };

        this.renderButton = this.renderButton.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    componentWillReceiveProps({message}) {
        if(!message) return;

        this.setState({
            buttons: _.map(message.buttons, (button)=>{return button;}),
            stickyButtons: _.map(message.stickyButtons, (button)=>{return button;})
        });
    }

    automationId(button, i = 0){
        return (button.text.includes('OTHER') && 'multiple-buttons-option-other') || (button.text.includes('MYSELF') && 'multiple-buttons-option-myself') || button.action ||`pickup_option_${i}`;
    }

    renderButton(button, i){
        const automationId = this.automationId(button, i);
        return(
            <div key={i} className="button" data-automation={dataAutomationAttr(automationId)} dangerouslySetInnerHTML={{__html: button.text}} onClick={()=>{this.props.onClick(this.props.message, button)}} />
        )
    }

    renderOptions(button, i){
        const counter = i + 1,
            automationId = this.automationId(button, counter);
        return(
            <option key={counter} value={counter} data-automation={dataAutomationAttr(automationId)} dangerouslySetInnerHTML={{__html: button.text}} />
        )
    }

    selectOption(i){
        this.setState({selectedButton: i});
        this.props.onClick(this.props.message, this.state.buttons.concat(this.state.stickyButtons)[i - 1]);
    }

    renderMobileSection(){
        return (
            <div className="buttons-container-mobile" data-automation={dataAutomationAttr(this.props.id)} >
                {this.state.buttons.map(this.renderButton)}
                {this.state.stickyButtons.map(this.renderButton)}
            </div>
        );
    }

    renderDesktopSection(){
        let msg = this.props.message;
        const selectId =  (typeof msg === 'object') ? msg.key : msg;

        return (
            <div className="buttons-container-desktop">
                <select id={`select_${selectId}`}
                        name="state"
                        value={this.state.selectedButton}
                        onChange={(event) => this.selectOption(event.target.value)}
                        data-automation={dataAutomationAttr(this.props.id)} >

                    <option key="0" value="0" disabled data-automation={dataAutomationAttr("pickup_option_0")}>{msg.placeholder}</option>
                    {this.state.buttons.concat(this.state.stickyButtons).map(this.renderOptions)}

                </select>
            </div>
        );
    }

    render(){
        return (
            <div id={this.props.id} className="message-input-container message-multiple-buttons input-root">
                <div className="buttons-wrapper">
                    {
                        isMobile() ? this.renderMobileSection() : this.renderDesktopSection()
                    }
                </div>
            </div>
        );
    }
}

export default MultipleButtons;